import $ from 'jquery';
import { parseQueryParams } from './shared/utils';
require('./page');

// @phone: moving homepage feature preview images to text block 
(function () {
  // / media query to check
  var phoneMQ = '(max-width: 800px) and (orientation: portrait)';
  // var phoneMQ = '(max-width: 1100px)';
  var isPhoneView = window.matchMedia(phoneMQ).matches;
  // matched or not
  if (isPhoneView) {
    var pas = $('#pricing-plans .pricing-actions-wrap')
    pas.each(function (i, pa) {
      if (pa) {
        var ptwrap = pa.parentNode.parentNode
        if (ptwrap) {
          ptwrap.insertBefore(pa, ptwrap.querySelector('.pricing-table-head'))
        }
      }
    })
  }
}());

// @phone: pricing tabs func 
(function () {
  // / media query to check
  var phoneMQ = '(max-width: 800px) and (orientation: portrait)';
  // var phoneMQ = '(max-width: 1100px)';
  // matched or not
  var isPhoneView = window.matchMedia(phoneMQ).matches;
  if (isPhoneView) {
    $("#pricing-cdn .subtext").text('viewers');

    var onPricingTabActive = function (el) {
      $('.plan-id-wrap').removeClass('tab-active')
      el = $(el)
      el.addClass('tab-active')
      // var tabIndex = el.data().productColId + 1
      var tabIndex = el.data().productColId

      $('#table-tab-css').remove()
      var css = document.createElement('style')
      css.id = 'table-tab-css'
      css.innerHTML = `.feat-row td:nth-of-type(${tabIndex}) {display: table-cell !important;}`
      document.body.appendChild(css)

    }

    var planHeads = $('.plan-id-wrap')
    planHeads.on('click', function () { onPricingTabActive(this) });
    onPricingTabActive(planHeads[0])

    var onPlanTypeChange = function () {
      var activeEntity = $(this).data('entity');
      var showCompanyPlans = activeEntity === 'company';
      if (this.tagName === 'INPUT') {
        showCompanyPlans = this.checked === true;
      }

      if (showCompanyPlans) {
        onPricingTabActive(planHeads[4])
      } else {
        onPricingTabActive(planHeads[0])
      }
    }

    $('.pricing-entity-switch .period-control').on('click', onPlanTypeChange)
    $('.pricing-switch-checkbox').on('change', onPlanTypeChange);

    // preselect 6th cdn pricing tab
    $('#pricing-cdn .plan-id-wrap[data-product-col-id=1]').click()
  }
}());

// live delivert type switch
// (function () {
//   $('.live-cat-tabs .live-cat-tab').on('click', function () {
//     var el = $(this)
//     el.addClass('selected')
//     el.siblings().removeClass('selected')
//   })
// })();

// init plans list type tabs
// (function () {
//   var tab_selector = '.live-cat-tabs[data-plans-list-selection] .live-cat-tab'
//   $(tab_selector).on('click', function () {

//     var targetPlansList = $(this).data().targetPlansList;
//     $(tab_selector).each(function (i, node) {
//       var el_ = $(this);
//       if (el_.data().targetPlansList === targetPlansList) {
//         el_.addClass('selected')
//       } else {
//         el_.removeClass('selected')
//       }
//     })

//     $('[data-plans-list-type]').each((function (i, node) {
//       node = $(node);
//       if (node.data().plansListType === targetPlansList) {
//         node.show()
//       } else {
//         node.hide()
//       }
//     }));
//   });
// })();

// force enable annual billing on pageload
(function () {
  // $('.pricing-switch-wrap [data-period="y"]').trigger('click')
  // $('.pricing-switch-wrap [data-period="y"]').get(0).click()
})();

// force enable annual billing on pageload
(function () {
  var params = parseQueryParams();
  // if (params.plans_category === 'live-stream-hosting') {
  //   $('.live-cat-tabs[data-plans-list-selection] .live-cat-tab').get(1).click()
  // }


  // if (window.location.href.includes('/live-stream-hosting')) {
  //   $('.live-cat-tabs[data-plans-list-selection] .live-cat-tab').get(1).click()
  // }

  // import axios from 'axios';
  // import $ from 'jquery';
  // import { parseQueryParams } from './shared/utils';

  // in-page pricing period toggle logic
  (function () {
    document.addEventListener("DOMContentLoaded", function () {
      const toggleButtons = document.querySelectorAll(".toggle-element");
      const priceElements = document.querySelectorAll(".plan-cost-amount");
      const billingLabels = document.querySelectorAll(".plan-billing-period");
      const pricingPeriodLinks = document.querySelectorAll("[data-monthly-href][data-yearly-href]");
      const legacyPeriodControls = document.querySelectorAll(".pricing-period-switch .period-control");
      const legacyPeriodLabels = document.querySelectorAll(".pricing-switch-wrap > label[data-period]");
      const yearlySwitches = document.querySelectorAll(".plan-yearly-switch input");
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

      var parsePriceNumber = function (value) {
        var normalizedValue = String(value || "").replace(/[^0-9.-]/g, "");
        var parsedValue = Number(normalizedValue);

        return Number.isFinite(parsedValue) ? parsedValue : null;
      };

      var formatPriceNumber = function (value, targetValue) {
        var targetText = String(targetValue || "");
        var decimals = targetText.includes(".")
          ? targetText.split(".")[1].length
          : 0;
        var formattedValue = decimals > 0
          ? value.toFixed(decimals)
          : String(Math.round(value));

        return "$" + Number(formattedValue).toLocaleString("en-US", {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        });
      };

      var animatePriceElement = function (el, targetValue, shouldAnimate) {
        var targetNumber = parsePriceNumber(targetValue);

        if (targetNumber === null) {
          el.textContent = targetValue;
          return;
        }

        var targetText = formatPriceNumber(targetNumber, targetValue);

        if (el.textContent.trim() === targetText) {
          return;
        }

        if (el._pricingNumberFrame) {
          cancelAnimationFrame(el._pricingNumberFrame);
        }

        if (!shouldAnimate || prefersReducedMotion.matches || document.hidden) {
          el.textContent = targetText;
          return;
        }

        var startNumber = parsePriceNumber(el.textContent);
        var fromNumber = startNumber === null ? targetNumber : startNumber;
        var duration = 520;
        var startTime = performance.now();

        el.classList.remove("pricing-number-animating");
        void el.offsetWidth;
        el.classList.add("pricing-number-animating");

        var tick = function (currentTime) {
          var progress = Math.min((currentTime - startTime) / duration, 1);
          var easedProgress = 1 - Math.pow(1 - progress, 3);
          var currentValue = fromNumber + ((targetNumber - fromNumber) * easedProgress);

          el.textContent = formatPriceNumber(currentValue, targetValue);

          if (progress < 1) {
            el._pricingNumberFrame = requestAnimationFrame(tick);
            return;
          }

          el.textContent = targetText;
          el._pricingNumberFrame = null;
          window.setTimeout(function () {
            el.classList.remove("pricing-number-animating");
          }, 80);
        };

        el._pricingNumberFrame = requestAnimationFrame(tick);
      };

      var applyPricingPeriod = function (selectedType, options) {
        selectedType = selectedType === "yearly" ? "yearly" : "monthly";
        const legacyPeriod = selectedType === "yearly" ? "y" : "m";
        const shouldAnimatePrices = Boolean(options && options.animatePrices);

        document.body.setAttribute("data-pricing-period", selectedType);
        document.body.classList.toggle("pricing-period-yearly", selectedType === "yearly");
        document.body.classList.toggle("pricing-period-monthly", selectedType === "monthly");

        document.querySelectorAll(".pricing-table").forEach(table => {
          table.classList.toggle("at-annual", selectedType === "yearly");
        });

        document.querySelectorAll(".plan-id-wrap").forEach(plan => {
          plan.classList.toggle("at-annual", selectedType === "yearly");
        });

        priceElements.forEach(el => {
          const monthlyPrice = el.getAttribute("data-monthly-price");
          const annualPrice = el.getAttribute("data-annual-price");

          if (!monthlyPrice && !annualPrice) {
            return;
          }

          animatePriceElement(
            el,
            selectedType === "monthly" ? monthlyPrice : annualPrice,
            shouldAnimatePrices
          );
        });

        billingLabels.forEach(label => {
          var monthlyLabel = label.getAttribute("data-monthly-label");
          var yearlyLabel = label.getAttribute("data-yearly-label");

          if (!monthlyLabel && !yearlyLabel) {
            return;
          }

          var billingLabel = label.querySelector(".plan-billing-label") || label;

          billingLabel.textContent = selectedType === "monthly"
            ? monthlyLabel || "Billed monthly"
            : yearlyLabel || "Billed yearly";
        });

        pricingPeriodLinks.forEach(link => {
          var periodHref = link.getAttribute(selectedType === "monthly"
            ? "data-monthly-href"
            : "data-yearly-href");

          if (periodHref) {
            link.setAttribute("href", periodHref);
          }
        });

        toggleButtons.forEach(btn => {
          const btnPeriodUnit = btn.getAttribute("data-type");
          const isSelected = btnPeriodUnit === selectedType;

          btn.classList.toggle("active", isSelected);
          btn.classList.toggle("toggle-element-checked", isSelected);
          btn.setAttribute("aria-pressed", String(isSelected));
        });

        legacyPeriodControls.forEach(control => {
          const isSelected = control.getAttribute("data-period") === legacyPeriod;

          control.classList.toggle("selected", isSelected);
          control.setAttribute("aria-pressed", String(isSelected));

          if (isSelected && control.parentElement) {
            control.parentElement.setAttribute("data-selected-period", legacyPeriod);
          }
        });

        legacyPeriodLabels.forEach(label => {
          label.classList.toggle("selected", label.getAttribute("data-period") === legacyPeriod);
        });

        yearlySwitches.forEach(input => {
          input.checked = selectedType === "yearly";
        });
      };

      // compact "Yearly" switch on the Pro card drives billing for every plan
      yearlySwitches.forEach(input => {
        input.addEventListener("change", function () {
          applyPricingPeriod(input.checked ? "yearly" : "monthly", { animatePrices: true });
        });
      });

      toggleButtons.forEach(button => {
        button.addEventListener("click", function () {
          applyPricingPeriod(button.getAttribute("data-type"), { animatePrices: true });
        });
      });

      legacyPeriodControls.forEach(control => {
        control.addEventListener("click", function () {
          applyPricingPeriod(control.getAttribute("data-period") === "y" ? "yearly" : "monthly", { animatePrices: true });
        });
      });

      legacyPeriodLabels.forEach(label => {
        label.addEventListener("click", function () {
          applyPricingPeriod(label.getAttribute("data-period") === "y" ? "yearly" : "monthly", { animatePrices: true });
        });
      });

      var selectedButton = document.querySelector(".toggle-element.toggle-element-checked") || toggleButtons[0];
      applyPricingPeriod(selectedButton ? selectedButton.getAttribute("data-type") : "monthly", { animatePrices: false });
    });


  }());

  // comparison table feature label tooltips
  document.addEventListener("DOMContentLoaded", function () {
    var tooltipRules = [
      {
        match: /html5 responsive player|html5 embed player/,
        text: "Responsive player for embedding your live stream or hosted video on desktop, tablet, and mobile screens."
      },
      {
        match: /cdn bandwidth pool/,
        text: "Included CDN data transfer for delivering your player stream to viewers."
      },
      {
        match: /concurrent viewers/,
        text: "How many viewers can watch your hosted player stream at the same time."
      },
      {
        match: /website embedding/,
        text: "Embed the Livepush player directly on your own website or landing page."
      },
      {
        match: /multi-bitrate transcoding|abr/,
        text: "Creates multiple video qualities so viewers can automatically receive the best stream for their connection."
      },
      {
        match: /dedicated m3u8|dash urls/,
        text: "Dedicated HLS or DASH playback URLs for custom players, apps, and private workflows."
      },
      {
        match: /real-time viewers analytics|viewers analytics/,
        text: "Live viewer statistics to help track audience activity while your stream is running."
      },
      {
        match: /add background poster|player branding/,
        text: "Customize the player with branded artwork, posters, logos, or visual identity."
      },
      {
        match: /add brand logo/,
        text: "Place your brand logo on top of the live player experience."
      },
      {
        match: /customize player color theme/,
        text: "Adjust the player colors so the embedded experience matches your brand."
      },
      {
        match: /allow with secret code|playback security/,
        text: "Restrict playback with access controls such as passwords or private viewing rules."
      },
      {
        match: /country whitelisting|geo block/,
        text: "Allow or block playback by viewer country for geo-targeted access control."
      },
      {
        match: /domain whitelisting|hot-link/,
        text: "Restrict playback so your stream only works on approved websites."
      },
      {
        match: /streaming hours/,
        text: "Total live streaming time included with the plan for the selected billing period."
      },
      {
        match: /live inputs/,
        text: "Number of simultaneous source streams you can connect to Livepush."
      },
      {
        match: /multistream to destinations/,
        text: "Total number of platform destinations you can stream to from Livepush."
      },
      {
        match: /destinations per platform/,
        text: "How many destinations you can add within the same platform, such as multiple YouTube channels."
      },
      {
        match: /custom rtmp/,
        text: "Send your stream to any service that accepts a custom RTMP server URL and stream key."
      },
      {
        match: /supports facebook pages/,
        text: "Stream directly to Facebook Pages and Groups from your connected Facebook account."
      },
      {
        match: /streamed recordings/,
        text: "Cloud recording time available for saving live events after they finish."
      },
      {
        match: /recordings retention/,
        text: "How long Livepush keeps your saved stream recordings available."
      },
      {
        match: /live stream pre-recorded videos/,
        text: "Schedule uploaded videos to play as live broadcasts at a chosen time."
      },
      {
        match: /concurrent pre-recorded live|conncurrent pre-recorded live/,
        text: "Number of pre-recorded live events that can run at the same time."
      },
      {
        match: /scheduled events in queue/,
        text: "Number of upcoming pre-recorded live events you can keep scheduled."
      },
      {
        match: /video storage/,
        text: "Cloud storage included for uploaded videos, playlist assets, and recordings."
      },
      {
        match: /max runtime per event/,
        text: "Maximum duration supported for a single scheduled pre-recorded live event."
      },
      {
        match: /video looping/,
        text: "Automatically repeat a video or playlist when the scheduled event reaches the end."
      },
      {
        match: /24\/7 streaming/,
        text: "Run continuous live channels or always-on streams without stopping between events."
      },
      {
        match: /team members/,
        text: "Invite teammates to help manage streams, schedules, and account workflows."
      },
      {
        match: /no livepush branding/,
        text: "Remove Livepush branding from the viewer-facing streaming experience."
      },
      {
        match: /live chat support/,
        text: "Get help from the Livepush support team through live chat."
      },
      {
        match: /multi chat widget/,
        text: "Use a single embeddable chat widget for messages across connected destinations."
      },
      {
        match: /real-time monitoring/,
        text: "Monitor live session health, status, and activity while streams are running."
      },
      {
        match: /historical stream reports/,
        text: "Access past stream reports and statistics for performance review."
      },
      // live stream hosting comparison labels
      {
        match: /brandable live player/,
        text: "Hosted HTML5 live player you can brand and embed on your own website."
      },
      {
        match: /monthly data transfer/,
        text: "CDN data transfer included for delivering your stream to viewers. Overages are billed per GB — streams are never cut off."
      },
      {
        match: /embed live player/,
        text: "Add the hosted player to any website with a simple embed code."
      },
      {
        match: /live transcoding/,
        text: "Cloud transcoding streams included for bitrate and quality control — no encoding hardware needed."
      },
      {
        match: /m3u8/,
        text: "Direct HLS/M3U8 and DASH links to play your stream in external players and apps."
      },
      {
        match: /srt output/,
        text: "RTMP and SRT output links for feeding your stream into other platforms or hardware."
      },
      {
        match: /live viewer analytics/,
        text: "Real-time viewer counts and audience stats while your stream is live."
      },
      {
        match: /compatible with multistreams/,
        text: "Works alongside Livepush multistreaming and pre-recorded live events."
      },
      {
        match: /custom background image/,
        text: "Show your own background or poster image in the player."
      },
      {
        match: /brand logo overlay/,
        text: "Overlay your logo on the player for branded playback."
      },
      {
        match: /custom player color theme/,
        text: "Match the player's colors to your brand."
      },
      {
        match: /password-protect/,
        text: "Restrict playback to viewers with your password."
      },
      {
        match: /restrict by country|geo-block/,
        text: "Allow or block playback based on viewer country."
      },
      {
        match: /restrict embed to your domain/,
        text: "Lock the player to your approved domains so other sites can't embed your stream."
      },
      {
        match: /simultaneous live streams/,
        text: "Number of live streams you can run at the same time."
      },
      {
        match: /stream to platforms at once/,
        text: "Total platforms you can multistream to simultaneously."
      },
      {
        match: /facebook pages & groups/,
        text: "Stream directly to Facebook Pages and Groups from your connected account."
      },
      {
        match: /recording saved per live event/,
        text: "Cloud recording time saved for each live event after it ends."
      },
      {
        match: /broadcast pre-recorded videos as live/,
        text: "Schedule uploaded videos to broadcast as live streams at a set time."
      },
      {
        match: /simultaneous pre-recorded streams/,
        text: "Number of pre-recorded live events that can run at the same time."
      },
      {
        match: /max pre-recorded event duration/,
        text: "Maximum length of a single pre-recorded live event."
      },
      {
        match: /24\/7 schedule channel/,
        text: "Always-on channel that plays your scheduled playlists around the clock."
      },
      {
        match: /branding & customizations/,
        text: "Make the player look like yours — posters, logos, and color themes."
      },
      {
        match: /security & protection/,
        text: "Control who can watch your stream and where it can be played."
      }
    ];

    var normalizeFeatureLabel = function (text) {
      return (text || "").replace(/\s+/g, " ").trim();
    };

    var getTooltipText = function (label) {
      var normalizedLabel = normalizeFeatureLabel(label).toLowerCase();
      var matchedRule = tooltipRules.find(function (rule) {
        return rule.match.test(normalizedLabel);
      });

      return matchedRule
        ? matchedRule.text
        : "Compare how this feature is included across each plan.";
    };

    document.querySelectorAll("#pricing-plans .pricing-table .feat-row:not(.feat-row-divider) > td:first-child").forEach(function (cell) {
      var label = normalizeFeatureLabel(cell.textContent);

      if (!label) {
        return;
      }

      var tooltip = getTooltipText(label);

      cell.classList.add("comparison-feature-tooltip-trigger");
      cell.setAttribute("data-tooltip", tooltip);
      cell.setAttribute("tabindex", "0");
      cell.setAttribute("aria-label", label + ": " + tooltip);
    });
  });

  // plan-card spec tooltips — same hint mechanism as the comparison view
  document.addEventListener("DOMContentLoaded", function () {
    var cardTooltipRules = [
      {
        match: /20 hours of streaming/,
        text: "Stream live for up to 20 hours every month on the free plan. Hit the cap and streaming pauses until next month — or upgrade to remove it."
      },
      {
        match: /no monthly streaming limit/,
        text: "The free plan's 20-hour monthly cap is removed — stream as many hours as you need, with no overage on stream time."
      },
      {
        match: /unlocks facebook/,
        text: "Adds Facebook Pages & Groups, Kick, and any custom RTMP service as destinations you can stream to."
      },
      {
        match: /1080p resolution/,
        text: "Broadcast in full HD 1080p to all your connected platforms."
      },
      {
        match: /4k resolution/,
        text: "Broadcast in up to 4K UHD on platforms that support it."
      },
      {
        match: /simultaneous (live )?streams/,
        text: "Number of live streams you can run at the same time."
      },
      {
        match: /video storage/,
        text: "Cloud storage for videos you upload to broadcast as pre-recorded live streams."
      },
      {
        match: /max pre-recorded event duration|pre-recorded events/,
        text: "Maximum length of a single pre-recorded live event."
      },
      {
        match: /player bandwidth|for viewers on your site/,
        text: "Data included each month for people watching on your own website player. Streaming to YouTube, Facebook and other platforms does not use it."
      },
      {
        match: /custom rtmp/,
        text: "Send your stream to any service that accepts a custom RTMP server URL and stream key."
      },
      {
        match: /hosted live/,
        text: "Embed a player for your live streams and uploaded videos on your own website."
      },
      {
        match: /24\/7 schedule channel/,
        text: "Always-on channel that plays your scheduled playlists around the clock."
      },
      {
        match: /queue and loop/,
        text: "Line up multiple videos to play in sequence and loop continuously on your channel."
      },
      {
        match: /edit your schedule/,
        text: "Update your 24/7 schedule on the fly — changes apply without stopping the stream."
      },
      {
        match: /invite team members/,
        text: "Give teammates their own access to manage streams and channels with you."
      },
      {
        match: /pre-recorded playlists/,
        text: "Number of pre-recorded playlists you can keep scheduled for broadcast."
      },
      {
        match: /priority support/,
        text: "Your chats and tickets jump to the front of the support queue."
      },
      {
        match: /go live with pre-recorded/,
        text: "Upload a video and broadcast it as a live stream at your scheduled time."
      },
      {
        match: /full cloud transcoding/,
        text: "The complete cloud transcoding and adaptive-bitrate stack, sized for your channels."
      },
      {
        match: /cloud transcoding stream/,
        text: "Streams transcoded in the cloud so playback stays smooth on every device and connection."
      },
      {
        match: /adaptive bitrate/,
        text: "Creates multiple video qualities so viewers can automatically receive the best stream for their connection."
      },
      {
        match: /petabyte/,
        text: "CDN delivery provisioned for petabyte-scale traffic and massive audiences."
      },
      {
        match: /akamai cdn/,
        text: "Streams are delivered worldwide over the Akamai CDN for fast, low-buffering playback."
      },
      {
        match: /rtmp\/hls\/m3u8|output urls/,
        text: "Dedicated RTMP, HLS, and M3U8 URLs for playback in custom players, apps, and private workflows."
      },
      {
        match: /on-air schedule/,
        text: "Update your schedule while the channel is live — changes apply without stopping the stream."
      },
      {
        match: /dedicated streaming server/,
        text: "Your own isolated streaming server with dedicated capacity — no shared infrastructure."
      },
      {
        match: /cname|white-label dns/,
        text: "Serve streams from your own domain with custom CNAME and white-label DNS."
      },
      {
        match: /slack access/,
        text: "A shared Slack channel with our engineering team for direct, real-time help."
      },
      {
        match: /large scale audience/,
        text: "Infrastructure sized for very large concurrent audiences."
      },
      {
        match: /live migration/,
        text: "We move your existing streams and setup over without downtime."
      },
      {
        match: /full setup/,
        text: "White-glove onboarding — our team configures channels, players, and destinations for you."
      },
      {
        match: /bandwidth/,
        text: "CDN data transfer included for delivering your streams and hosted player to viewers."
      },
      {
        match: /destination/,
        text: "How many channels you can connect per platform and stream to at the same time."
      }
    ];

    var normalizeSpecLabel = function (text) {
      return (text || "").replace(/\s+/g, " ").trim();
    };

    // Simplified social plan cards: hints on group titles and on the plain
    // sub-features. The text is wrapped in a .plan-hint span so the dotted
    // underline and the bubble only cover the words, not the whole row.
    var groupHintRules = [
      {
        match: /^player & cdn$/,
        text: "Your own live player for your website, delivered over the Akamai CDN. The figure is the viewer bandwidth included."
      },
      {
        match: /^live streaming$/,
        text: "Go live from your encoder or browser and stream to all your platforms at once. The figure is how many hours you can stream each month."
      },
      {
        match: /^scheduled streams$/,
        text: "Upload a video and broadcast it to your platforms as a live event at a time you choose. The figure is how many can run at the same time."
      },
      {
        match: /^social channels$/,
        text: "Stream to your social accounts at the same time. The figure is how many accounts you can connect on each platform."
      }
    ];

    var simpleItemHintRules = [
      {
        match: /live streams? (at once|at a time)/,
        text: "Number of live streams you can run at the same time, each going out to its own set of platforms."
      },
      {
        match: /destinations in total/,
        text: "The most places you can stream to at the same time, counting every account on every platform."
      },
      {
        match: /accounts? per platform/,
        text: "How many accounts you can connect on a single platform, for example several YouTube channels or Facebook pages."
      },
      {
        match: /custom destination limits/,
        text: "Destination counts sized to your channels and platforms."
      },
      {
        match: /^unlimited viewers$/,
        text: "Viewers watching on YouTube, Facebook, Twitch and other platforms are hosted by them, so there is no cap and no bandwidth cost to you."
      },
      {
        match: /live player for websites/,
        text: "Embed a branded live player on your own website so viewers can watch there too, alongside your social platforms."
      },
      {
        match: /^no recordings$/,
        text: "Live streams are not recorded on the Free plan. Upgrade to Pro to keep a recording of each event."
      },
      {
        match: /recordings per event/,
        text: "Each live stream is recorded in the cloud, up to this length per event."
      },
      {
        match: /events up to|no event length limit/,
        text: "Maximum length of a single pre-recorded live event."
      }
    ].concat(cardTooltipRules);

    var attachHint = function (el, rules) {
      var label = normalizeSpecLabel(el.textContent);
      var normalizedLabel = label.toLowerCase();
      var rule = rules.find(function (r) { return r.match.test(normalizedLabel); });

      if (!label || !rule) {
        return;
      }

      var hint = document.createElement("span");
      hint.className = "plan-hint";
      hint.setAttribute("data-tooltip", rule.text);
      hint.setAttribute("tabindex", "0");
      hint.setAttribute("aria-label", label + ": " + rule.text);
      while (el.firstChild) {
        hint.appendChild(el.firstChild);
      }
      el.appendChild(hint);
    };

    document.querySelectorAll(".plan-grid-simple .plan-group-title").forEach(function (title) {
      attachHint(title, groupHintRules);
    });

    document.querySelectorAll(".plan-grid-simple .plan-group-items li:not(.plan-group-platforms):not(.plan-group-caption)").forEach(function (item) {
      attachHint(item, simpleItemHintRules);
    });

    document.querySelectorAll(".modern-pricing-table .plan-specs-list .plan-spec:not(.plan-spec-inherit)").forEach(function (spec) {
      var destinations = spec.querySelector(".plan-platform-destinations[aria-label]");
      var caption = spec.querySelector(".plan-spec-caption");
      var label = normalizeSpecLabel(destinations ? destinations.getAttribute("aria-label") : (caption ? caption.textContent : ""));

      if (!label) {
        return;
      }

      var normalizedLabel = label.toLowerCase();
      var matchedRule = cardTooltipRules.find(function (rule) {
        return rule.match.test(normalizedLabel);
      });

      if (!matchedRule) {
        return;
      }

      spec.classList.add("plan-spec-tooltip-trigger");
      spec.setAttribute("data-tooltip", matchedRule.text);
      spec.setAttribute("tabindex", "0");
      spec.setAttribute("aria-label", label + ": " + matchedRule.text);
    });
  });

  // in-page customer reviews scroller
  document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll(".customer-review-card-list");

    sliders.forEach(slider => {
      const cards = slider.children;
      const cardWidth = cards[0].offsetWidth + parseInt(getComputedStyle(cards[0]).marginRight);
      let scrollPosition = 0;
      let isPaused = false;

      // Clone cards to enable seamless looping
      const cloneCount = Math.ceil(slider.offsetWidth / cardWidth) + 1;
      for (let i = 0; i < cloneCount; i++) {
        slider.appendChild(cards[i % cards.length].cloneNode(true));
      }

      function autoScroll() {
        if (!isPaused) {
          scrollPosition += 0.5;
          if (scrollPosition >= slider.scrollWidth / 2) {
            scrollPosition = 0;
            slider.scrollLeft = 0;
          } else {
            slider.scrollLeft = scrollPosition;
          }
        }

        // setTimeout(() => {
        //   autoScroll()
        // }, 0);
        requestAnimationFrame(autoScroll);
      }

      autoScroll();

      // Pause/resume on hover
      slider.addEventListener("mouseover", () => isPaused = true);
      slider.addEventListener("mouseout", () => isPaused = false);
    })

  });

  // in-page pricing testimonial controls
  document.addEventListener("DOMContentLoaded", function () {
    const rails = document.querySelectorAll(".pricing-testimonials-quote-rail");

    rails.forEach(rail => {
      const controls = rail.querySelectorAll(".pricing-testimonial-actions a[href^='#pricing-testimonial-']");

      controls.forEach(control => {
        control.addEventListener("click", function (event) {
          const targetId = control.getAttribute("href").slice(1);
          const target = document.getElementById(targetId);

          if (!target || !rail.contains(target)) {
            return;
          }

          event.preventDefault();

          const targetLeft = target.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;

          rail.scrollTo({
            left: targetLeft,
            behavior: "smooth"
          });
        });
      });
    });
  });

})();

// Compare plans: sticky plan header that compacts smoothly (desktop only)
(function () {
  var init = function () {
    var root = document.getElementById("pricing-plans");
    var head = root && root.querySelector(".pricing-head");
    if (!root || !head) {
      return;
    }

    var desktop = window.matchMedia("(min-width: 1200px)");
    var collapsibles = function () {
      return head.querySelectorAll(".plan-desc, .plan-billing-period");
    };
    var delta = 0;
    var stuck = false;
    // zero-height marker at the header's natural position
    var sentinel = document.createElement("div");
    sentinel.className = "pricing-head-sentinel";
    sentinel.setAttribute("aria-hidden", "true");
    sentinel.style.cssText = "height:0;margin:0;padding:0;";
    head.parentNode.insertBefore(sentinel, head);
    var ticking = false;

    var measure = function () {
      // natural heights so max-height can animate from a real px value
      collapsibles().forEach(function (el) {
        el.style.maxHeight = "none";
        el.style.maxHeight = el.scrollHeight + "px";
      });
      var wasStuck = head.classList.contains("is-stuck");
      head.classList.add("is-measuring");
      head.classList.remove("is-stuck");
      var full = head.offsetHeight;
      head.classList.add("is-stuck");
      var compact = head.offsetHeight;
      if (!wasStuck) {
        head.classList.remove("is-stuck");
      }
      void head.offsetHeight;
      head.classList.remove("is-measuring");
      delta = Math.max(0, full - compact);
      if (wasStuck) {
        head.style.marginBottom = delta + "px";
      }
    };

    var update = function () {
      ticking = false;
      if (!desktop.matches) {
        return;
      }
      var nav = document.querySelector(".navbar");
      var top = nav ? Math.round(nav.getBoundingClientRect().bottom) : 69;
      root.style.setProperty("--pricing-sticky-top", top + "px");

      // stick once the header reaches the navbar; natural position comes from
      // the element just before it in flow, which never moves while stuck
      var shouldStick = sentinel.getBoundingClientRect().top <= top + 0.5;

      if (shouldStick !== stuck) {
        stuck = shouldStick;
        head.classList.toggle("is-stuck", stuck);
        head.style.marginBottom = stuck ? delta + "px" : "";
      }
    };

    var onScroll = function () {
      if (document.hidden) {
        update();
        return;
      }
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };

    var setup = function () {
      if (desktop.matches) {
        root.classList.add("has-sticky-head");
        measure();
        update();
      } else {
        root.classList.remove("has-sticky-head");
        head.classList.remove("is-stuck");
        head.style.marginBottom = "";
        collapsibles().forEach(function (el) { el.style.maxHeight = ""; });
        stuck = false;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () { setup(); });
    if (desktop.addEventListener) {
      desktop.addEventListener("change", setup);
    }
    // fonts / price animation can change heights after load
    window.addEventListener("load", setup);
    setup();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}());
